export default __webpack_public_path__ + "static/media/chatbot-image.4a0a010a.svg";